import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// Import the CSS file for styling

const cities = [
  "Mumbai", "Delhi", "Bengaluru", "Hyderabad", "Ahmedabad",
  "Chennai", "Kolkata", "Pune", "Jaipur", "Surat"
  // Add more cities as needed
];

const JobSearchContainer = () => {
  const [jobTitle, setJobTitle] = useState("");
  const [city, setCity] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    console.log({ jobTitle, city });
    navigate(`/job-list?title=${jobTitle}&city=${city}`);
  };

  return (
    <div className="job-search-container">
      <div className="form-group row">
        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Search Job Title"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <select
            className="form-control"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          >
            <option value="" disabled>Select City</option>
            {cities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobSearchContainer;
